import { render } from "./CreateUser.vue?vue&type=template&id=42fdc7a8"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\NodeProjects\\FibreFrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__